import { Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { RankingsService } from './rankings.service';
import { Ranking } from './ranking';

@Injectable({
  providedIn: 'root'
})
export class Ranking$Resolver implements Resolve<Observable<Ranking>> {

  constructor(
    private readonly rankingsService: RankingsService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Observable<Ranking>> {
    return of(this.rankingsService.ranking$(route.params.rankingId));
  }
}
